/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type UserActionFilterConfigColumn =
  (typeof UserActionFilterConfigColumn)[keyof typeof UserActionFilterConfigColumn];

export const UserActionFilterConfigColumn = {
  user_action: 'user_action',
} as const;
